$(document).ready(function(){

    // function runResultsCalc(){
    //     console.log('Runned Results Calc');
    //     var data_sleep = parseFloat($('.quiz_data_calc__js').attr('data-sleep'));
    //     var data_focus = parseFloat($('.quiz_data_calc__js').attr('data-focus'));
    //     if (data_sleep > data_focus){
    //         setTimeout(function(){
    //             window.location.href = '/products/ultimate-methylene-blue'
    //         },1000);
    //     }
    //     else{
    //         setTimeout(function(){
    //             window.location.href = '/products/ultimate-methylene-blue'
    //         },1000);
    //     }
    // }
    
    var current_url = window.location.href;
    if (current_url.indexOf('#') != -1){
    var url_splitted = current_url.split('#');
    window.location.replace(url_splitted[0]);
    }


      $('.qh_btn').click(function(event){
        event.preventDefault();
        $('html, body').animate({
           scrollTop: $(".qe_grid").offset().top-200
        }, 500);
      });

  
// Setup the quiz'

    $('.Quiz_frontpage_trigger__js').click(function(){
        var current_url = window.location.href;
        var url_splitted = current_url.split('#');
        var new_url = url_splitted[0] + '#' +1;
        // console.log(new_url);
        window.location.replace(new_url);
        $('.Quiz_main_frontpage').hide();
        $('#shopify-section-footer-main').hide();
        $('.Quiz_header').hide();
        $('.Quiz_header_when_in_quiz').show();
        $('.Quiz_question_1__js').css('display', 'flex');
        var question_length = parseFloat($('.Question_amount').attr('data-questions_amount'));
        $('.Quiz_header_question_info_js').text('1/'+question_length);

        var value = $(this).text();
        // console.log(value);
    });

    // Question next

    $('.Next_question_trigger__js').click(function(){

        var data_sleep = parseFloat($('.quiz_data_calc__js').attr('data-sleep'));
        var data_focus = parseFloat($('.quiz_data_calc__js').attr('data-focus'));

        var current_data = $(this).attr('data');
        if (current_data == 'sleep'){
            data_sleep++;
        }
        else if (current_data == 'focus'){
            data_focus++;
        }
        $('.quiz_data_calc__js').attr('data-sleep', data_sleep);
        $('.quiz_data_calc__js').attr('data-focus', data_focus);

        console.log(data_sleep, data_focus);

        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));

        // Indexing quiz questions
        var current_url = window.location.href;
        if (current_url.indexOf('#') != -1){
            var url_splitted = current_url.split('#');
            var next_url_index = next_index;
            var new_url = url_splitted[0] + '#' +next_url_index;
            // console.log(new_url);
            window.location.replace(new_url);
        }

        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val())+1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100/only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);
        // if (next_index < 6){
        //      width = (next_index) * multiplier;
        // }
        // else if (next_index >= 6 && next_index < 12){
        //      width = (next_index)* multiplier;
        // }
        // else{
        //     width = next_index *multiplier;
        // }
        // console.log(next_index);

        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function() {
            if (question_length == next_index){
                $('.Quiz_question').hide();
                $('.Quiz_loading_page').css('display', 'flex');
                // runResultsCalc();
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(current_question_index+'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '0');
                $('.Quiz_header_back').css('cursor', 'default');
                Start_calculating();
            }
            else{
                $('.Quiz_question').hide();
                $('.Quiz_question_'+next_index+'__js').css('display', 'flex');
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(current_question_index+'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').css('cursor', 'pointer');
                $('.Quiz_header_back').attr('data-current', next_index);
            }
        },200);

    
        
    });

    $('.Multiple_question_trigger__js').click(function(){
        $(this).toggleClass('active');
        var selected_selector = 0;
        $('.Multiple_question_trigger__js').each(function(){
            if ($(this).hasClass('active')){
                selected_selector++;
            }
        });
        console.log(selected_selector);
        if (selected_selector != 0){
            $('.Multiple_question_next__js').removeClass('disabled');
        }
        else{
            $('.Multiple_question_next__js').addClass('disabled');
        }
    });

    $('.Multiple_question_next__js').click(function(){
        if ($(this).hasClass('disabled')){

        }
        else{
            var current_index = parseFloat($(this).attr('data-index'));
            var next_index = current_index + 1;
            var current_question_index = parseFloat($(this).attr('data-question-index'));

            // Indexing quiz questions
            var current_url = window.location.href;
            if (current_url.indexOf('#') != -1){
                var url_splitted = current_url.split('#');
                var next_url_index = next_index;
                var new_url = url_splitted[0] + '#' +next_url_index;
                // console.log(new_url);
                window.location.replace(new_url);
            }

            // console.log(next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_'+next_index+'__js').css('display', 'flex');
            $('.Multiple_question_next__js').addClass('disabled');
            $('.Multiple_question_trigger__js').removeClass('active');
            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val())+1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100/only_questions;
            // if (next_index < 6){
            //     width = (next_index+2) * multiplier;
            // }
            // else if (next_index >= 6 && next_index < 12){
            //     width = (next_index +1)* multiplier;
            // }
            // else{
            //     width = next_index *multiplier;
            // }
            width = (current_question_index) * multiplier;
            console.log(width, current_question_index, multiplier);
            if (question_length == next_index){
                $('.Quiz_question').hide();
                $('.Quiz_loading_page').css('display', 'flex');
                runResultsCalc();
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(current_question_index+'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '0');
                $('.Quiz_header_back').css('cursor', 'pointer');
                Start_calculating();
            }
            else{
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(current_question_index+'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').css('cursor', 'pointer');
                $('.Quiz_header_back').attr('data-current', next_index);
            }
        }
    
    });

    $('.Text_question_next__js').click(function(){
            var current_index = parseFloat($(this).attr('data-index'));
            var next_index = current_index + 1;
            var next_question_index = parseFloat($('.Quiz_question_'+current_index+'__js').attr('data-question-index'));
            console.log(current_index, next_index, next_question_index)
            // Indexing quiz questions
            var current_url = window.location.href;
            if (current_url.indexOf('#') != -1){
                var url_splitted = current_url.split('#');
                var next_url_index = next_index;
                var new_url = url_splitted[0] + '#' +next_url_index;
                // console.log(new_url);
                window.location.replace(new_url);
            }
            // console.log(next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_'+next_index+'__js').css('display', 'flex');
            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val())+1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100/only_questions;
            // if (next_index < 6){
            //     width = (next_index+2) * multiplier;
            // }
            // else if (next_index >= 6 && next_index < 12){
            //     width = (next_index +1)* multiplier;
            // }
            // else{
            //     width = next_index *multiplier;
            //  }
            width = next_question_index *multiplier;

            if (question_length == next_index){
                $('.Quiz_question').hide();
                $('.Quiz_loading_page').css('display', 'flex');
                runResultsCalc();
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(next_question_index +'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '0');
                $('.Quiz_header_back').css('cursor', 'default');
                Start_calculating();
            }
            else{
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(next_question_index+'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').attr('data-current', next_index);
                $('.Quiz_header_back').css('cursor', 'pointer');
            }

    
    });

    $('.Quiz_header_back').click(function(){
        var current_index = parseFloat($('.Quiz_header_back').attr('data-current'));
        if (current_index > 1){
            var next_index = current_index -1;
            var next_question_index = parseFloat($('.Quiz_question_'+next_index+'__js').attr('data-question-index'))-1;
        }
        else{
            var next_index = current_index;
        }

        if (current_index > 1){
            // Indexing quiz questions
            var current_url = window.location.href;
            if (current_url.indexOf('#')){
                var url_splitted = current_url.split('#');
                var next_url_index = next_index;
                var new_url = url_splitted[0] + '#' +next_url_index;
                // console.log(new_url);
                window.location.replace(new_url);
            }

            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val())+1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100/only_questions;
            // if (next_index < 6){
            //      width = (next_index+2) * multiplier;
            // }
            // else if (next_index >= 6 && next_index < 12){
            //      width = (next_index +1)* multiplier;
            // }
            // else{
            //     width = next_index *multiplier;
            // }
            width = next_question_index *multiplier;
            $('.Quiz_header_back').attr('data-current', next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_'+next_index+'__js').css('display', 'flex');
            $('.Quiz-header_progres_bar__inner').css('width', width+'%');
            $('.Quiz_header_question_info_js').text(next_question_index+'/'+only_questions);
            if(next_index == 1){
                $('.Quiz_header_back').css('opacity', '0');
                $('.Quiz_header_back').css('cursor', 'default');
            }
        }
        
    });




$('.Science_cell_header__js').click(function(){
    $(this).toggleClass('active');
    $(this).find('.Offer_science_cell_text').slideToggle();
});

$('.Offer_faq_tab').click(function(){
    $(this).toggleClass('active');
    $(this).find('.Offer_faq_answer').slideToggle();
});

$('.Header_scroll_js').click(function(){
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1){
        
    }
    $('html, body').animate({
        scrollTop: $(".Offer__section__js").offset().top-100
    }, 500);
});

// 15minutes timer

function shortTimer(){
    function timerCountDown(){
        var timeLeft = parseFloat($('.Offer_get_your_plan_timer_seconds').attr('data'));
        timeLeft--;
        $('.Offer_get_your_plan_timer_seconds').attr('data', timeLeft);
        var minutes = timeLeft/60;
        minutes = Math.floor(minutes);
        var seconds = timeLeft - (minutes * 60);
        // console.log(minutes, seconds, 'timer');
        $('.Offer_get_your_plan_timer_minutes').text(minutes);
        $('.Offer_get_your_plan_timer_seconds').text(seconds);
    }

    setInterval(timerCountDown, 1000);
     
}

shortTimer();


// Random numbers generator 

function getRandomArbitrary(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
var similar_result = getRandomArbitrary(75, 87);
var statistic_data_1 = getRandomArbitrary(76, 86);
var statistic_data_2 = getRandomArbitrary(65, 76);
var statistic_data_3 = getRandomArbitrary(41, 58);
var your_score = getRandomArbitrary(25, 34);

// $('.Offer_procrastination_similar_score').text(similar_result+'%');
$('.summary_number_1__js').text(statistic_data_1+'%');
$('.summary_number_2__js').text(statistic_data_2+'%');
$('.summary_number_3__js').text(statistic_data_3+'%');

});


// EMAIL FIELD
// function   {
//     function checkEmail() {
//         var checkingItemAttr = $('.kl-private-reset-css-Xuajs1').find('p').find('span').text();
//         console.log(checkingItemAttr);
//         if (checkingItemAttr.indexOf('THANKS FOR SIGNING UP!') !== -1) {
//             clearInterval(intervalId); // Clear the interval when the condition is met
//             window.location = '/pages/quiz-results';
//         }
//     }

//     var intervalId = setInterval(checkEmail, 500); // Store the interval ID

//     // Optionally, you can also clear the interval after a certain time to prevent indefinite execution
//     // setTimeout(function() {
//     //     clearInterval(intervalId);
//     // }, 60000); // Clear the interval after 60 seconds (adjust as needed)
// }


function runEmailChecker() {

     // Calculating Percentage

    function Calculating(){
        var data = parseFloat($('.Quiz_calculating_percent__js').attr('data'));
        if (data <  100){
            if (data < 20){
                data++;
            }
            if (data >= 20 && data < 22){
                data += 0.15;
            }
            if (data >= 22 && data < 29){
                data += 1.3;
            }
            if (data >= 29 && data < 32){
                data += 3;
            }
            if (data >= 32 && data < 45){
                data +=4;
            }
            if (data >= 45 && data < 48){
                data += 0.7;
            }
            if (data >= 48 && data < 57){
                data += 1.4;
            }
            if (data >= 57 && data < 87){
                data += 4;
            }
            if (data >= 87 && data < 93){
                data += 2.3;
            }
            if (data >= 93 && data < 97){
                data += 4;
            }
            if (data >= 97 && data < 100){
                data += 0.4;
            }
            if ( data >= 100){
                var next_url = $('.Quiz_calculating_percent__js').attr('next_url');
                window.location.replace(next_url);
            }
        }
        data_rounded = Math.round(data);
        console.log(data_rounded, 'procentai');
        $('.Quiz_calculating_percent__js').attr('data', data);
        $('.Quiz_calculating_percent__js').text(data_rounded+'%');
    }
    
    function Start_calculating(){
        setInterval(Calculating, 100);
    }


    function checkEmail() {
      var checkingItemAttr = $('.kl-private-reset-css-Xuajs1').find('p').find('span').text();
      // console.log(checkingItemAttr);
     if (checkingItemAttr.indexOf('A message has been sent to confirm your subscription.') != -1){
        // console.log('test'); 
        $('.Quiz_question').hide();
        $('.Quiz_question_after_email').css('display', 'flex');
        var next_index = $('.Quiz_question_after_email').find('.Text_question_next__js').attr('data-index');
        var question_length = parseFloat($('.Question_amount').val())+1;
        // $('.Quiz_header_question_info_js').text(next_index+'/'+question_length);
        $('.Quiz_header_back').attr('data-current', next_index);
        $('.kl-private-reset-css-Xuajs1').find('p').find('span').text('Your Results');
        $('.kl-private-reset-css-Xuajs1').find('p').css('opacity', '0');
        $('.Quiz_header_back_inner').hide();

        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;

        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));

        $('.Quiz_question').hide();
        $('.Quiz_loading_page').css('display', 'flex');
        // runResultsCalc();
        $('.Quiz-header_progres_bar__inner').css('width', '100%');
        $('.Quiz_header_question_info_js').text(only_questions+'/'+only_questions);
        $('.Quiz_header_back').css('opacity', '0');
        $('.Quiz_header_back').css('cursor', 'default');
        Start_calculating();
      }
    }
    setInterval(checkEmail, 20);
  }

  runEmailChecker();


// Middle calculation
function MiddleCalculating(){
    var data = parseFloat($('.Quiz_middle_loading__js').attr('data'));
    if (data <  100){
        if (data < 20){
            data++;
        }
        if (data >= 20 && data < 22){
            data += 0.15;
        }
        if (data >= 22 && data < 29){
            data += 1.3;
        }
        if (data >= 29 && data < 32){
            data += 3;
        }
        if (data >= 32 && data < 45){
            data +=4;
        }
        if (data >= 45 && data < 48){
            data += 0.7;
        }
        if (data >= 48 && data < 57){
            data += 0.4;
        }
        if (data >= 57 && data < 87){
            data += 3;
        }
        if (data >= 87 && data < 93){
            data += 2;
        }
        if (data >= 93 && data < 97){
            data += 4;
        }
        if (data >= 97 && data < 100){
            data += 0.4;
        }
        if ( data >= 100){
        //    Passing to the next part of Quiz
            var current_index = parseFloat($('.Quiz_middle_loading__js').attr('data-index'));
            var next_index = current_index + 1;
            var next_question_index = parseFloat($('.Quiz_question_'+current_index+'__js').attr('data-question-index'));
            console.log(current_index, next_index, next_question_index);
            // Indexing quiz questions
            var current_url = window.location.href;
            if (current_url.indexOf('#') != -1){
                var url_splitted = current_url.split('#');
                var next_url_index = next_index;
                var new_url = url_splitted[0] + '#' +next_url_index;
                // console.log(new_url);
                window.location.replace(new_url);
            }
            // console.log(next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_'+next_index+'__js').css('display', 'flex');
            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val())+1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100/only_questions;
            // if (next_index < 6){
            //     width = (next_index+2) * multiplier;
            // }
            // else if (next_index >= 6 && next_index < 12){
            //     width = (next_index +1)* multiplier;
            // }
            // else{
            //     width = next_index *multiplier;
            //  }
             width = (next_index) * multiplier;
                $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_question_info_js').text(next_question_index+'/'+only_questions);
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').css('cursor', 'pointer');
                $('.Quiz_header_back').attr('data-current', next_index);
        }
    }
    data_rounded = Math.round(data);
    $('.Quiz_middle_loading__js').attr('data', data);
    $('.Quiz_middle_loading__js').text(data_rounded+'%');
}

function Start_middle_calculating(){
    setInterval(MiddleCalculating, 100);
}

// Buy products tracking with analytics

$(document).on('click','.Offer_product_atc_button', function(){
  var currentTitle = $(this).attr('ga_data');
  console.log(currentTitle);

  var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1){
    }

});

$(document).on('click','.Thrive_Cart_close_buton', function(){
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1){
    }
});



$('.Thrive_Cart_close_buton').click(function(){
    location.reload();
    // Enable redirect for exit intent
   var wait_url = $('.wait_page_url').attr('data');
   if(typeof wait_url === "undefined"){
       wait_url = '/pages/wait';
    }
    window.location = wait_url;
});

$(document).on('click','.thrivecart-button', function(){
    $('.Thrive_Cart_close_buton').show();
});


$('.Offer_main_includes_form_button').click(function(){
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1){
    }
    $('html, body').animate({
        scrollTop: $(".Offer__section__js").offset().top-50
    }, 500);
});

$('.Main_offer_buttons').click(function(){
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1){
    }
    $('html, body').animate({
        scrollTop: $(".Offer__section__js").offset().top-50
    }, 500);
});


$('.Offer_main_faq_cell').click(function(){
    if ($(this).hasClass('active')){
        $(this).toggleClass('active');
        $(this).find('.Faq_thumb').slideToggle();
    }
    else{
        $(this).toggleClass('active');
        $('.Faq_thumb').slideUp();
        $(this).find('.Faq_thumb').slideToggle();
    }
    // $('.Faq_thumb').removeClass('loaded_active');
});




